export const createTest = /* GraphQL */ `
  mutation CreateTest($input: TestInsert!) {
    createTest(input: $input) {
      id
      createdAt
      updatedAt
    }
  }
`;
